import type moment from 'moment'

import { dateToString } from 'modules/core/lib/dates'
import { Collection } from 'modules/core/lib/mobx-rest'

import type Employee from 'modules/employees/store/models/Employee'
import type Allowance from 'modules/timeoff/store/models/Allowance'
import AllowanceStat from 'modules/timeoff/store/models/AllowanceStat'

class Stats extends Collection<AllowanceStat> {
  model() {
    return AllowanceStat
  }

  findOrInitializeBy(
    employee: Employee,
    allowance: Allowance,
    referenceDate: moment.Moment
  ): AllowanceStat {
    const employeeId = employee.attributes.id
    const allowanceId = allowance.attributes.id
    const dateString = dateToString(referenceDate, 'backend')
    const statId = `${employeeId}/${allowanceId}/${dateString}`
    const fetchedStat = this.get(statId)

    if (fetchedStat) return fetchedStat

    const newStat = new AllowanceStat({
      id: statId,
      cycles: [],
    })
    this.add(newStat)

    return newStat
  }
}

const singleton: Stats = new Stats()

export default singleton
